<!-- 新建/编辑设施管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="设施分类" prop="classification">
              <div class="list-img-box">
                <el-select v-model="formValidate.classification" placeholder="请选择设施分类" :style="{width:'100%'}">
                  <el-option v-for="item in classificationList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="公寓楼设施分类" prop="apartmentBuilding" v-if="formValidate.classification == 2">
              <div class="list-img-box">
                <el-select v-model="formValidate.apartmentBuilding" placeholder="请选择设施分类" :style="{width:'100%'}">
                  <el-option v-for="item in apartmentBuildingList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="设施名称" prop="name">
              <div class="list-img-box">
                <el-input placeholder="请输入设施名称" v-model="formValidate.name"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
              <div class="list-img-box">
                <el-upload
                  class="avatar-uploader"
                  action="https://applets.ustayz.co/api/file/upload"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :http-request="handleHttpRequestPhoto">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
          <!-- 保存 -->
          <div :style="{textAlign:'center'}">
            <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
            <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'FacilitiesManagementOperation',
    data () {
      return {
        formValidate: {
          name: '',//添加设施名称
          classification:"1",//添加设施分类1.房间设施, 2.公寓楼设施，
          apartmentBuilding:"1",//公寓楼设施-1.公共设施/2.公寓服务/3.室外设施/4.安保设施
          icon:"",//图片
        },
        imageUrl: '', //图标
        ruleValidate: { //学校非空验证
          classification: [
            { required: true, message: '请选择设施分类', trigger: 'blur'}
          ],
          name: [
            { required: true, message: '请输入设施名称', trigger: 'blur'}
          ],
          icon: [
            { required: true, message: '请选择图标', trigger: 'change'}
          ]
        },
        classificationList:[{label:'房间设施',value:'1'},{label:'公寓楼设施',value:'2'}],//添加设施分类1.房间设施, 2.公寓楼设施，
        apartmentBuildingList:[{label:'公共设施',value:'1'},{label:'公寓服务',value:'2'},{label:'室外设施',value:'3'},{label:'安保设施',value:'4'}]//添加公寓楼设施-1.公共设施/2.公寓服务/3.室外设施/4.安保设施
      }
    },
    methods: {
      // 图片上传
      async handleHttpRequestPhoto(data){
        let imageUrl = data.file;
        //调用axios上传
        let formData = new FormData();
        formData.append('file',imageUrl,'DX.jpg')
        await this.$api.fileUpload(formData).then(res => {
          if (res.data.status == 200) {
            this.formValidate.icon = res.data.data[0].path;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 图片上传
       handleAvatarSuccess(res, file){
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      // 图片上传钱验证
      beforeAvatarUpload(file){
        const isJPG =  file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "image/gif"||
          file.type == "image/jpg";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
          if (valid) {
            let params = {},title="新增";
            if (this.$route.query.data == undefined){
              params = {
                type:this.formValidate.classification,
                name:this.formValidate.name,
                category:this.formValidate.apartmentBuilding,
                icon:this.formValidate.icon,
                status:1
              }
              this.$api.saveOrUpdateFacilities({parameter: JSON.stringify(params)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/FacilitiesManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            } else {
              params = {
                id:this.$route.query.data.id,
                type:this.formValidate.classification,
                name:this.formValidate.name,
                category:this.formValidate.apartmentBuilding,
                icon:this.formValidate.icon,
                status:1
              }
              title = "编辑";
              this.$api.houseEditFacilities({parameter: JSON.stringify(params)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/FacilitiesManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
          }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/FacilitiesManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.name = this.$route.query.data.name;
        this.formValidate.classification = this.$route.query.data.type.toString();
        this.formValidate.apartmentBuilding = this.$route.query.data.category.toString();
        this.imageUrl = api_url+"/"+this.$route.query.data.icon;
        this.formValidate.icon = this.$route.query.data.icon;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */

</style>





// WEBPACK FOOTER //
// src/components/Menu/FacilitiesManagementOperation.vue